import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

// badge
export function badgeAjaxTable(limit,pagination,id,login,badge_name,created_at){
	const data = request({
		url: config.url+'badge_list/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&login=' + login + '&badge_name=' + badge_name + '&created_at=' + created_at,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeInfo(id){
	const data = request({
		url: config.url+'badge_list/info?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeAdd(postData){
	const data = request({
		url: config.url+'badge_list/badge',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function badgeDelete(postData){
	const data = request({
		url: config.url+'badge_list/delete',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

export function getBonusTopup(id){
	const data = request({
		url: config.url+'badge_list/topup?id='+id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function bonusTopup(postData){
	const data = request({
		url: config.url+'badge_list/topup',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}